const getCsrfTokenHeaders = () => {
    const token = sessionStorage.getItem('vid_ww') ?? undefined;

    if (!token) {
        return {};
    }

    return { vid_ww: token };
};

export default getCsrfTokenHeaders;
